import { THPRoles } from '../../../model/forms'
import { AOM_HP_ROLES, PBM_HP_ROLES } from '../configs'

interface IFilterHPRolesOptions {
  isAOM?: boolean
  isPBM?: boolean
  region?: string
}

export function filterHPRoles(role: THPRoles, options: IFilterHPRolesOptions) {
  const { isAOM, isPBM, region } = options

  const isAOMRole = AOM_HP_ROLES.includes(role.title)
  const isPBMRole = PBM_HP_ROLES.includes(role.title)

  const isPublicRole = !isAOMRole && !isPBMRole

  const isInRegion = (region && role.region.includes(region)) || role.region === 'Global'

  return isInRegion && (isPublicRole || (isAOMRole && isAOM) || (isPBMRole && isPBM))
}
